var t=function(t){return null!=t&&"object"==typeof t};export{t as default};
